import {action, makeAutoObservable} from "mobx"
import {RootStore} from "../index";
import ElementModel from "../../model/ElementModel";
import {numbers} from "@material/slider";

export class PageCardStore {
    private rootStore: RootStore | undefined;

    arElement = {
        id: numbers,
        name: '',
        code: '',
        price: {},
        propsNoFilter: {
            productDescription: ''
        },
    };
    code = '';
    public error: string = '';


    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    init(code: string) {
        this.code = code;
        window.localStorage.setItem("codePage", "1")
        this.reload();
    }

    @action reload = () => {
        ElementModel.getElement(this.code, this.rootStore?.mainStore.getClientId(), this.setElement, this.setError);

    }

    @action reloadForActualPrice = (code: string) => {
        ElementModel.getElement(code, this.rootStore?.mainStore.getClientId(), this.setElement, this.setError);
    }

    @action reloadMain = () => {
        if (this.code) {
            this.reload();
        }
    }


    @action
    setElement = (result: any) => {
        let BreadCrumbs = result.data.BreadCrumbs;
        if (result.data.row.propsNoFilter.isSellout) {
            BreadCrumbs.splice(2, 0, { name: "Распродажа", url: "/catalog/filter/isSellout-is-true" });
        }

        this.arElement = result.data.row;

        const updatePrice = (store: any) => {
            store.find((item: any) => {
                if (item.id === this.arElement.id) {
                    item.price = this.arElement.price;
                    return true;
                }
                return false;
            });
        };

        updatePrice(this.rootStore?.pageCatalogStore.arItems);
        updatePrice(this.rootStore?.componentTopSearchStore.rows);
        updatePrice(this.rootStore?.pageMainStore.arItemsNew);
        updatePrice(this.rootStore?.pageMainStore.arItemsSpecials);
        updatePrice(this.rootStore?.pageMainStore.arItemsStock);
        updatePrice(this.rootStore?.pageMainStore.arItemsLoyalty);

        this.rootStore?.basePageStore.setBreadCrumbs(BreadCrumbs, 'catalog').setTitleInBreadCrumbs();
    }

    @action
    setError = (error: any) => {
        console.log(error);
        // this.error = error.response.data.message;
    }
}
